<template>
  <AdminImage v-bind="$attrs" :src="src" :alt="title || '商品图片'" :width="width" :height="height" :preview="false" @click.stop="open" />
  <AdminImagePreview v-if="state.visible" :visible="state.visible" :src="state.sources[state.index] || ''" :title="title || '商品图片'" :count="state.sources.length" :index="state.index" :busy="state.busy" :error="state.error" @previous="move(-1)" @next="move(1)" @close="close" />
</template>
<script lang="ts">export default {inheritAttrs:false}</script>
<script setup lang="ts">
import {onBeforeUnmount,watch} from 'vue'
import AdminImage from './AdminImage.vue'
import AdminImagePreview from './AdminImagePreview.vue'
import product from '@/api/product'
import store from '@/store'
import {createProductImageGallery} from '@/utils/productImageGallery'
const props=defineProps<{src?:string;width?:string|number;height?:string|number;productId?:number|string;attachments?:unknown[];baseUrl?:string;title?:string}>()
const {state,open:openGallery,close,move}=createProductImageGallery(async id=>{
  const response=await product.getProductAttachs(id,0)
  if(!Array.isArray(response.data))throw new Error('Invalid product images')
  return response.data
},()=>props.baseUrl || store.getters.settings?.imgurl?.value || '')
function open(){return openGallery(props.src || '',props.productId,props.attachments)}
watch(()=>[props.src,props.productId,props.attachments,props.baseUrl],close,{flush:'sync'})
onBeforeUnmount(close)
</script>
